"use client";

import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import Cookies from "js-cookie";
import { initializeGA4, updateGAConsent } from "@/lib/analytics";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("tracking-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set("tracking-consent", "granted", { expires: 365 }); // 1 year
    setShowBanner(false);

    // Update Datadog RUM consent if available
    if (window.DD_RUM && typeof window.DD_RUM.setTrackingConsent === "function") {
      window.DD_RUM.setTrackingConsent("granted");
    }

    updateGAConsent("granted");

    // Dispatch custom event to notify GoogleAnalyticsProvider
    window.dispatchEvent(new Event('consentChanged'));

    // Initialize GA4 after consent is granted
    initializeGA4();
  };

  const declineCookies = () => {
    Cookies.set("tracking-consent", "not-granted", { expires: 365 }); // 1 year
    setShowBanner(false);

    // Update Datadog RUM consent if available
    if (window.DD_RUM && typeof window.DD_RUM.setTrackingConsent === "function") {
      window.DD_RUM.setTrackingConsent("not-granted");
    }

    updateGAConsent("denied");

    // Dispatch custom event to notify GoogleAnalyticsProvider
    window.dispatchEvent(new Event('consentChanged'));
  };

  if (!showBanner) return null;

  return (
    <div className="fixed right-0 bottom-0 left-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg">
      <div className="container flex flex-col gap-4 justify-between items-center mx-auto sm:flex-row">
        <p className="text-sm text-gray-600">
          {`We use cookies and similar technologies to help personalize content, enhance your experience, and analyze our traffic. By clicking "Accept", you consent to our use of cookies.`}
        </p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={declineCookies}>
            Decline
          </Button>
          <Button onClick={acceptCookies}>Accept</Button>
        </div>
      </div>
    </div>
  );
}
